import { render } from "./SingleChoice.vue?vue&type=template&id=9ff39272&scoped=true&ts=true"
import script from "./SingleChoice.vue?vue&type=script&lang=ts"
export * from "./SingleChoice.vue?vue&type=script&lang=ts"

import "./SingleChoice.vue?vue&type=style&index=0&id=9ff39272&scoped=true&lang=scss"
import "./SingleChoice.vue?vue&type=style&index=1&id=9ff39272&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ff39272"]])

export default __exports__